//#region Imports
import { createAnydoAuthErrorByStatus } from "./utils/createAnydoAuthErrorByStatus";
//#endregion

//#region Helpers
export async function getAuthResponseObject<T = object>(response: Response) {
  const text = await response.text();
  let data, errorMessage;

  try {
    data = JSON.parse(text) as T;
  } catch {
    if (text !== "") {
      errorMessage = text || "";
    }
  }

  return {
    data,
    error: errorMessage,
    status: response.status,
  };
}
//#endregion

export async function fetchAuth<T = object | undefined>(input: RequestInfo, init?: RequestInit): Promise<T> {
  let response;
  try {
    response = await fetch(input, init);
  } catch {
    throw createAnydoAuthErrorByStatus();
  }

  const { status, data, error } = await getAuthResponseObject<T>(response);

  // status === 200 -> Success
  // Fixing issue when server returns status=200 with error
  if (status === 200 && error === undefined) {
    return data!;
  }

  throw createAnydoAuthErrorByStatus(status, data ?? error);
}
